'use client';

import { useEffect, useRef, useState } from 'react';
import AddToCart from '@next-app/components/PDP/AddToCart/AddToCart';
import Script from 'next/script';
import getUniqueKey from './get-unique-key';

export const ExternalAddToCartButton = () => {
  const childRef = useRef<Record<number, { triggerAction: () => void }>>({});
  const [buttons, setButtons] = useState(false);

  const setChildRef = (id: any) => (ref: { triggerAction: () => void }) => {
    if (!childRef.current) {
      childRef.current = {};
    }
    if (ref) {
      childRef.current[id] = ref;
    }
  };

  useEffect(() => {
    const handleTrigger = (event: any) => {
      console.log('Event received:', event.detail); // Debugging log
      setTimeout(() => {
        childRef?.current?.[event.detail]?.triggerAction();
      }, 200);
    };

    window.addEventListener('addProductToCartEvent', handleTrigger);

    return () => {
      window.removeEventListener('addProductToCartEvent', handleTrigger);
    };
  }, []);

  useEffect(() => {
    const initAddToCartButtons = (event: any) => {
      const data = event.detail;
      const buttonsList = data.ids.map((id: string, key: number) => (
        <div key={getUniqueKey(key, id)}>
          <AddToCart ref={setChildRef(id)} productId={id} selectedSku={null} />
        </div>
      ));
      setButtons(buttonsList);
    };

    window.addEventListener('initAddToCartButtons', initAddToCartButtons);

    return () => {
      window.removeEventListener('initAddToCartButtons', initAddToCartButtons);
    };
  }, []);

  return (
    <>
      <Script id={'dy_add-to-cart'} type="text/javascript">
        {`
            const button = document.createElement('button');
            button.innerText = "Click Me";
            button.classList.add('d-none');
            button.addEventListener("click", () => {
              window.triggerAddToCartEvent('WD111');
            });
            document.body.appendChild(button);
            window.initAddButtonsEvent = (data) => {
                window.dispatchEvent(new CustomEvent("initAddToCartButtons", {detail: data}));
          };
            window.triggerAddToCartEvent = (data) => {
                window.dispatchEvent(new CustomEvent("addProductToCartEvent", { detail: data }));
          };
        `}
      </Script>
      <div style={{ display: 'none' }}>
        {buttons}
        {/* <AddToCart ref={childRef} productId={'WD111'} selectedSku={null} /> */}
      </div>
    </>
  );
};
